import React from 'react';
import PropTypes from 'prop-types';

import _ from 'lodash';

import { Card, Grid, Typography } from '@mui/material';
import { DashboardHelpers } from 'utils';
import { useFields } from 'hooks';
import { green } from '@mui/material/colors';

const PlanTile = ({ plan, onClick }) => {
  const { fetchField, fields } = useFields();
  const planInfo = plan.data;

  const field = _.find([...fields, ...fields], { id: plan.layer_id });
  if (!field) {
    fetchField(plan.layer_id);
  }

  const formatDateTime = (dateTimeString) => {
    const options = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone, // Modify the timezone if needed
    };

    const formattedDateTime = new Date(dateTimeString)?.toLocaleString('en-US', options);
    return formattedDateTime;
  };

  return (
    <Card onClick={onClick} sx={{ height: '8rem', width: '8rem', margin: 1 }}>
      <Grid
        container
        direction="column"
        justifyContent="center"
        alignContent="center"
        alignItems="center"
        onClick={onClick}
      >
        <Grid item>
          <Typography variant="subtitle1">{formatDateTime(plan.time)}</Typography>
        </Grid>
        <Grid item fontSize={48} sx={{ color: green[400] }}>
          {DashboardHelpers.getIconForPlanType(planInfo?.plan_type)}
        </Grid>
        <Grid item textAlign="center">
          <Typography variant="subtitle2">{planInfo?.plan_type ?? 'None Specified'}</Typography>
          <Typography variant="caption">{field?.name ?? 'None Specified'}</Typography>
        </Grid>
      </Grid>
    </Card>
  );
};

PlanTile.propTypes = {
  plan: PropTypes.object.isRequired,
  onClick: PropTypes.func,
};

PlanTile.defaultProps = {
  onClick: () => {},
};

export default PlanTile;
